module.exports = __webpack_public_path__ + "img/farzana-christopher-88.7541dfd3.jpg";